import { Icons24 as o } from "./icons-24/index.js";
import { Icons40 as r } from "./icons-40/index.js";
import { Other as m } from "./other/index.js";
const n = {
  ...o,
  ...r,
  Other: m
};
export {
  n as icons
};
